<template>
  <div class="table-slots-container">
    <div class="row paddingTop27px margin-top-25px background-color-table">
      <div class="col-md-5">
        <div class="title-header" v-if="title === 'Screeners'">Biometric Screening</div>
        <div class="title-header" v-if="title === 'Slots'">
         <div v-if="fluShot === 1">Flu Shot</div>
          <div v-if="fluShot === 2">Covid Vaccine</div>
          <div v-if="fluShot === 3">Covid & Flu Shots</div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="block-open-wrapper group-btn">
          <button class="ap-btn destructive" @click="blockOpenStaffing(true)">Block all</button>
          <button class="ap-btn primary" @click="blockOpenStaffing(false)">Open all</button>
        </div>
      </div>
      <div class="col-md-1"></div>
    </div>
    <div class="row number-slots-container">
      <div class="col-md-12 number-slots-defautl">
        <div v-if="title == 'Screeners'" class="col-md-12 for-screening body-text">
          <p class="col-md-5">Screener Station ({{maxValueStaff}})</p>
          <div v-if="title == 'Screeners'" class="col-md-6 d-flex justify-content-end">
            <b-button class="btn-minus" @click="onAddOrRemoveScreener(false)">
              <img src='../../../static/img/minus.svg' alt='minus'/>
            </b-button>
            <b-button class="btn-add" @click="onAddOrRemoveScreener(true)">
              <img src='../../../static/img/add-icon.svg' alt='add'/>
            </b-button>
          </div>
           <div class="col-md-1"></div>
        </div>
        <div v-else class=" col-md-12 for-flu-shot">
          <div class="slots-count body-text">Slots ({{eventDetail.maxParticipantPerSlot}})</div>
          <div class="ap-field-input-wrapper">
            <div class="ap-input-wrapper">
              <input class="input body-text" @blur="updateCustomSlotFluShot" v-model="eventDetail.maxParticipantPerSlot">
              <!--<div class="icon-wrapper-field"></div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row background-color-table">
      <div class="col-md-12">
        <div class="screener-table">
          <div class="s-header">
            <div class="s-header-wrapper">
              <div>
                <div class="s-container" :id="'s-container-' + title">
                  <div class="s-wrapper">
                    <div class="icon-wrapper left" @click="moveLeft()">
                      <div class="left-icon"></div>
                    </div>
                    <div class="icon-wrapper right" @click="moveRight()">
                      <div class="right-icon"></div>
                    </div>
                    <div style="min-width: 80px;width: 80px; float: left; height: 1px;"></div>
                    <div v-for="(slotHeaderNumber, index) in numberColumn" class="s-header-column"
                         v-if="slotHeaderNumber > startColumn && slotHeaderNumber <= (startColumn + numberShowColumn)">
                      <div class="staffing-select-column"
                           :class="(selectedColumns.indexOf(index) >= 0) ? 'always-show' : null">
                        <label class="custom-checkbox custom-control">
                          <input type="checkbox" autocomplete="off"
                                 class="custom-control-input"
                                 @click="toggleSelectColumn(index, slotsGroup)"
                                 :checked="(selectedColumns.indexOf(index) >= 0)">
                          <span aria-hidden="true" class="custom-control-indicator"></span> <span
                          class="custom-control-description"></span>
                        </label>
                      </div>
                        {{slotHeaderNumber}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="s-body">
            <div v-for="(slotGroup, indexTime) in slotsGroup" class="s-body-row">
              <div class="row-wrapper">
                <div class="time-wrapper">
                  <div class="s-body-time label-text"><span class="">{{slotGroup.timeString}}</span></div>
                  <div class="staffing-select-row">
                    <label class="custom-checkbox custom-control"
                           :class="(selectedRows.indexOf(indexTime) >= 0) ? 'always-show' : null">
                      <input type="checkbox" autocomplete="off"
                             class="custom-control-input"
                             @click="toggleSelectRow(indexTime, slotGroup.eventSlots)"
                             :checked="selectedRows.indexOf(indexTime) >= 0">
                      <span aria-hidden="true" class="custom-control-indicator"></span> <span
                      class="custom-control-description"></span>
                    </label>
                  </div>
                </div>
                <div class="slot-wrapper">
                  <div class="s-container">
                    <div class="s-wrapper s-body-wrapper"
                         :class="(selectedRows.indexOf(indexTime) >= 0) ? 'selected-staffing-item' : null">
                      <div v-for="(eventSlot, indexSlot) in slotGroup.eventSlots" class="s-body-item"
                           :class="(selectedItemIds.indexOf(eventSlot.id + '-' + eventSlot.screenerNumber) >= 0) ? 'selected-staffing-item' : 'un-selected-staffing-item'"
                           v-if="indexSlot >= startColumn && indexSlot < (startColumn + numberShowColumn)">
                        <div class="staffing-check"
                             :class="(selectedItemIds.indexOf(eventSlot.id + '-' + eventSlot.screenerNumber) >= 0) ? 'always-show' : null">
                          <label class="custom-checkbox custom-control">
                            <input type="checkbox" autocomplete="off"
                                   class="custom-control-input"
                                   :value="eventSlot.id"
                                   @click="toggleSelect(eventSlot)"
                                   :checked="(selectedItemIds.indexOf(eventSlot.id + '-' + eventSlot.screenerNumber) >= 0)">
                            <span aria-hidden="true" class="custom-control-indicator"></span> <span
                            class="custom-control-description"></span>
                          </label>
                        </div>
                        <div v-if="eventSlot.eventParticipants != null && eventSlot.eventParticipants.length" class="bullet green"></div>
                        <div v-if="eventSlot.eventParticipants != null && eventSlot.eventParticipants.length" class="text">
                          {{eventSlot.eventParticipants[0].firstName}} {{eventSlot.eventParticipants[0].lastName}}
                        </div>
                        <div v-if="eventSlot.status == 'OPEN'" class="bullet grey"></div>
                        <div v-if="eventSlot.status == 'OPEN'" class="text">{{eventSlot.status}}</div>
                        <div v-if="eventSlot.status == 'BLOCKED'" class="bullet red"></div>
                        <div v-if="eventSlot.status == 'BLOCKED'" class="text">{{eventSlot.status}}</div>
                        <div class="action-btn">
                          <div class="dot"></div>
                          <div class="dot"></div>
                          <div class="dot"></div>
                          <ul class="action-menu">
                            <li v-if="eventSlot.status !== 'BOOKED'" @click="blockOpenThisStaffing(eventSlot)">
                              {{eventSlot.status === 'BLOCKED' ? 'Open' : 'Block'}} slot
                            </li>
                            <li v-if="eventSlot.status === 'BOOKED'"
                                @click="clearSingleSlot({eventSlot: eventSlot, index:{time: indexTime, slot: indexSlot}})">
                              Clear slot
                            </li>
                            <li @click="showPatientDetails()" v-if="eventSlot.eventParticipants == null || eventSlot.eventParticipants.length === 0">Details</li>
                            <li @click="showPatientDetails(eventSlot.eventParticipants[0])" v-if="eventSlot.eventParticipants != null && eventSlot.eventParticipants.length">Details</li>
                            <li @click="addParticipant(eventSlot)" v-if="eventSlot.status !== 'BOOKED'">Add Participant</li>
                            <li @click="editParticipant(eventSlot)" v-if="eventSlot.status === 'BOOKED'">Edit Participant</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PatientDetailModal></PatientDetailModal>
    <AddParticipantModal :requestUpdateTable="requestUpdateTable"></AddParticipantModal>
    <SearchParticipantModal :requestUpdateTable="requestUpdateTable"></SearchParticipantModal>
  </div>
</template>
<script>
  import AddParticipantModal from '../../components/modal/patient/AddParticipantModal.vue';
  import PatientDetailModal from '../../components/modal/patient/PatientDetailModal';
  import SearchParticipantModal from '../../components/modal/patient/SearchParticipantModal.vue';
  import {mapActions} from 'vuex';
  const tableScreenerName = 'Screeners';
  export default {
    name: 'event-slots',
    components: {
      AddParticipantModal,
      PatientDetailModal,
      SearchParticipantModal
    },
    props: {
      eventDetail: {
        required: true
      },
      eventId: 0,
      addOns: '',
      title: '',
      maxValueStaff: 0,
      fluShot: null
    },
    data () {
      return {
        selectedItems: [],
        selectedItemIds: [],
        selectedRows: [],
        selectedColumns: [],
        numberColumn: 0,
        startColumn: 0,
        numberShowColumn: 0,
        slotsGroup: {},
        maxParticipantPerSlot: 0,
        numberSlotCustom: 1,
        participant: {
          firstName: '',
          lastName: '',
          email: '',
          employeeId: '',
          hasBiometric: false,
          hasFluShot: 0
        },
        fromBiometric: true,
        isCovidVaccine: false,
        isCovidFluShots: false
      }
    },
    methods: {
      ...mapActions({
        updateEventStaffing: 'ACTION_BLOCK_OPEN_STAFFING',
        clearSlot: 'ACTION_CLEAR_SLOT',
        updateMaxNumberFluShot: 'UPDATE_MAX_NUMBER_FLU_SHOT'
      }),
      requestUpdateTable () {
        this.$emit('RELOAD_TABLE_STAFFING');
      },
      updateCustomSlotFluShot () {
        if (isNaN(this.eventDetail.maxParticipantPerSlot)) {
          this.$toast.success('Slots is not a number.', '', {
            ...this.$toastOpt.optError
          });
          return;
        }
        let body = {
          eventId: this.eventId,
          maxParticipantPerFluShot: this.eventDetail.maxParticipantPerSlot
        };
        this.updateMaxNumberFluShot(body).then((response) => {
          this.$toast.success('Update successfully', '', {
            ...this.$toastOpt.optSuccess
          });
          response = {
            ...this.eventDetail,
            eventSlotGroupsFLuShotOnly: response.eventSlotGroupsFLuShotOnly,
            maxParticipantPerSlot: this.eventDetail.maxParticipantPerSlot
          };
          this.renderEventStaffing(response);
        }).catch((e) => { console.log(e); });
      },
      blockOpenStaffing (isBlock) {
        let body = [];
        this.selectedItems.forEach((item) => {
          body.push({
            ...item,
            status: isBlock ? 'BLOCKED' : 'OPEN'
          });
        });
        this.updateEventStaffing(body).then(response => {
          if (response.message === null) {
            this.$toast.success('Update successfully', '', {
              ...this.$toastOpt.optSuccess
            });
            this.selectedItems.forEach(item => {
              item.status = isBlock ? 'BLOCKED' : 'OPEN'
            });
          } else {
            this.$toast.success(response.message, '', {
              ...this.$toastOpt.optError
            });
          }
        });
      },
      renderEventStaffing (eventDetail) {
        this.selectedItems = [];
        this.selectedItemIds = [];
        this.selectedRows = [];
        this.selectedColumns = [];
        this.eventDetail = eventDetail;
        let containerElm = document.getElementById('s-container-' + this.title);
        if (!containerElm) {
          return;
        }
        let width = containerElm.offsetWidth;
        // 105 = width of screener staffing cell
        this.numberColumn = 0;
        this.slotsGroup = [];
        this.numberShowColumn = Math.floor((width - 80) / 105);
        if (this.eventDetail.eventSlotGroups.length && this.title === 'Screeners') {
          this.numberColumn = this.eventDetail.eventSlotGroups[0].eventSlots.length;
          this.slotsGroup = this.eventDetail.eventSlotGroups;
        } else if (this.eventDetail.eventSlotGroupsFLuShotOnly && this.eventDetail.eventSlotGroupsFLuShotOnly.length && this.title === 'Slots') {
          this.numberColumn = this.eventDetail.eventSlotGroupsFLuShotOnly[0].eventSlots.length; // this.eventDetail.eventSlotGroupsFLuShotOnly[0].eventSlots.length;
          this.slotsGroup = this.eventDetail.eventSlotGroupsFLuShotOnly;
          // Flu Shot/Covid Shot Slots Management
          if (this.addOns !== undefined) {
            if (this.addOns.includes('covidVaccine')) {
              this.isCovidVaccine = true
            } else if (this.addOns.includes('covidFluShots')) {
              this.isCovidFluShots = true
            }
          }
        }
      },
      blockOpenThisStaffing (eventSlot) {
        this.selectedItems = [];
        this.selectedItemIds = [];
        let isBlock = eventSlot.status !== 'BLOCKED';
        this.toggleSelect(eventSlot);
        this.blockOpenStaffing(isBlock);
      },
      toggleSelect (eventSlot) {
        let index = this.selectedItemIds.indexOf(eventSlot.id + '-' + eventSlot.screenerNumber);
        if (index < 0) {
          this.selectedItemIds.push(eventSlot.id + '-' + eventSlot.screenerNumber);
        } else {
          this.selectedItemIds.splice(index, 1);
        }
        index = this.selectedItems.indexOf(eventSlot);
        if (index < 0) {
          this.selectedItems.push(eventSlot);
        } else {
          this.selectedItems.splice(index, 1);
        }
      },
      clearSingleSlot (updateObj) {
        this.requestUpdateTable();
        this.clearSlot(updateObj.eventSlot).then(response => {
          if (response.message) {
            this.$toast.success(response.message, '', {
              ...this.$toastOpt.optError
            });
          } else {
            if (response.eventSlotDto.fluShot) {
              this.eventDetail.eventSlotGroupsFLuShotOnly[updateObj.index.time].eventSlots[updateObj.index.slot] = response.eventSlotDto || [];
            } else {
              this.eventDetail.eventSlotGroups[updateObj.index.time].eventSlots[updateObj.index.slot] = response.eventSlotDto || [];
            }

            this.renderEventStaffing(this.eventDetail);
            this.$toast.success('Removed successfully', '', {
              ...this.$toastOpt.optSuccess
            });
            // No need pop-up to show
            // this.$toastr('success', 'Update event successful!', '');
          }
        })
      },
      showPatientDetails (patientDetail) {
        if (patientDetail !== null && patientDetail !== undefined) {
          this.$modal.show('patientDetailModal', patientDetail);
        }
      },
      addParticipant (slot) {
        let fromBiometric = this.title === tableScreenerName;
        slot = {
          isEdit: false,
          fromBiometric: fromBiometric,
          hasFluShot: 0,
          hasBiometric: false,
          ...slot
        };
        // this.$modal.show('modalAddParticipant', slot);
        this.$modal.show('modalSearchParticipant', {eventId: this.eventId, participant: slot, eventDetail: this.eventDetail, fluShot: this.fluShot});
      },
      editParticipant (slot) {
        // this.participant = {...slot};
        // this.fromBiometric = false;
        slot = {
          isEdit: true,
          ...slot
        };
        // this.$modal.show('modalAddParticipant', slot);
        this.$modal.show('modalAddParticipant', {eventId: this.eventId, slot: slot, eventDetail: this.eventDetail});
      },
      toggleSelectRow (index, eventSlots) {
        let indexRow = this.selectedRows.indexOf(index);
        if (indexRow < 0) {
          this.selectedRows.push(index);
          this.toggleAddRow(true, eventSlots);
        } else {
          this.selectedRows.splice(indexRow, 1);
          this.toggleAddRow(false, eventSlots);
        }
      },
      toggleSelectColumn (index, eventSlotGroups) {
        let indexColumn = this.selectedColumns.indexOf(index);
        if (indexColumn < 0) {
          this.selectedColumns.push(index);
          this.toggleAddColumn(true, index, eventSlotGroups);
        } else {
          this.selectedColumns.splice(indexColumn, 1);
          this.toggleAddColumn(false, index, eventSlotGroups);
        }
      },
      toggleAddColumn (isAdd, indexColumn, eventSlotGroups) {
        if (isAdd) {
          eventSlotGroups.forEach((item) => {
            let eventSlots = item.eventSlots;
            let selectedItem = eventSlots[indexColumn];
            if (!selectedItem) {
              return;
            }
            let index = this.selectedItemIds.indexOf(selectedItem.id + '-' + selectedItem.screenerNumber);
            if (index < 0) {
              this.selectedItemIds.push(selectedItem.id + '-' + selectedItem.screenerNumber);
            }
            index = this.selectedItems.indexOf(selectedItem);
            if (index < 0) {
              this.selectedItems.push(selectedItem);
            }
          });
        } else {
          eventSlotGroups.forEach((item) => {
            let eventSlots = item.eventSlots;
            let selectedItem = eventSlots[indexColumn];
            if (!selectedItem) {
              return;
            }
            let index = this.selectedItemIds.indexOf(selectedItem.id + '-' + selectedItem.screenerNumber);
            if (index >= 0) {
              this.selectedItemIds.splice(index, 1);
            }
            index = this.selectedItems.indexOf(selectedItem);
            if (index >= 0) {
              this.selectedItems.push(selectedItem);
            }
          });
        }
      },
      toggleAddRow (isAdd, eventSlots) {
        if (isAdd) {
          eventSlots.forEach((item) => {
            let index = this.selectedItemIds.indexOf(item.id + '-' + item.screenerNumber);
            if (index < 0) {
              this.selectedItemIds.push(item.id + '-' + item.screenerNumber);
            }
            index = this.selectedItems.indexOf(item);
            if (index < 0) {
              this.selectedItems.push(item);
            }
          });
        } else {
          eventSlots.forEach((item) => {
            let index = this.selectedItemIds.indexOf(item.id + '-' + item.screenerNumber);
            if (index >= 0) {
              this.selectedItemIds.splice(index, 1);
            }
            index = this.selectedItems.indexOf(item);
            if (index >= 0) {
              this.selectedItems.splice(index, 1);
            }
          });
        }
      },
      moveLeft () {
        this.startColumn--;
        if (this.startColumn < 0) {
          this.startColumn = 0;
        }
      },
      moveRight () {
        if (this.startColumn + this.numberShowColumn < this.numberColumn) {
          this.startColumn++;
        }
      },
      onAddOrRemoveScreener (value) {
        this.$emit('add-remove-staff', {
          eventStaffRole: 'screener',
          addStaff: value,
          addStaffScreener: false
        });
      }
    },
    computed: {
    },
    mounted () {
    }
  }
</script>
<style lang="less" scoped="">
  @import '../../styles/variables.less';
  .table-slots-container{
    .number-slots-container{
      background-color: #f5f5f5;
    }
    .number-slots-defautl{
       padding: 0;
      .for-screening{
        margin-top: 24px;
        height: 36px;
        display: flex;
        padding: 0;

        .btn-add, .btn-minus {
          background: #FFFFFF;
          border: 1px solid #B9B9B9;
          box-sizing: border-box;
          border-radius: 4px;
          margin-left: 1rem;
        }

        .btn-add {
          margin-right: 5.5rem;
        }
      }

      .for-flu-shot{
        margin-top: 24px;
        display: flex;
        align-items: center;
        background-color: @grey-5;

        .ap-field-input-wrapper{
          margin-left: 24px;

          .ap-input-wrapper{
            .input{
              height: 32px;
              width: 72px;
              color: @black-3;
            }

            .icon-wrapper-field{
              background: url('/static/img/sort-solid.svg') center no-repeat;
              right: 8px;
            }
          }
        }
      }
    }
  }
  .background-color-table {
    background-color: #F5F5F5;

    .space-between-row {
      margin-top: 24px;
      margin-bottom: 15px;
    }
    .group-btn{
      .ap-btn{
        font-size: 16px;
        font-weight: 600;
        padding: 6px 24px;
        & + .ap-btn {
          margin-left: 16px;
        }
      }
    }
    .block-open-wrapper {
      display: flex;
      justify-content: flex-end;
    }
    .block-all {
      height: 32px;
      width: 133px;
      background-color: @red-1;
      border-radius: 4px;
      display: inline-block;
      cursor: pointer;
    }
    .open-all {
      height: 32px;
      width: 125px;
      background-color: @light-blue;
      border-radius: 4px;
      display: inline-block;
      margin-left: 4px;
      cursor: pointer;
    }
    .title-header {
      color: #444444;
      font-family: @font-family-main;
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 0.17px;
      line-height: 28px;
    }
    .screeners-label {
      color: @grey-8;
      font-family: @font-family-main;
      font-size: 16px;
      line-height: 24px;
    }
    .time-slot-right {
      text-align: right;
      padding-right: 5px;
    }
    .screener-table {
      margin-top: 15px;
      .s-header {
        .s-header-wrapper{
          width: 100%;
        }
        .icon-wrapper {
          border: solid 1px #00A4D6;
          position: absolute;
          border-radius: 10px;
          /*top: -5px;*/
          &:hover {
            cursor: pointer;
          }
          &.left {
            left: 50px;
          }
          &.right {
            right: 60px;
          }
          .left-icon {
            z-index: 7;
            width: 17px;
            height: 17px;
            background: url('../../../static/img/backward-line-blue.svg');
          }
          .right-icon {
            z-index: 7;
            width: 17px;
            height: 17px;
            background: url('../../../static/img/forward-line-blue.svg');
          }
        }
        .s-header-column {
          float: left;
          width: 81px;
          height: 17px;
          color: #626262;
          font-family: "Open Sans", sans-serif;
          font-size: 12px;
          line-height: 17px;
          margin-right: 24px;
          &:hover {
            .staffing-select-column {
              display: block;
            }
          }
          .staffing-select-column {
            float: left;
            height: 24px;
            width: 24px;
            margin-top: -4px;
            display: none;
          }
        }
      }
      .s-body {
        margin-top: 8px;
        .s-body-row {
          .row-wrapper{
            display: flex;
            .slot-wrapper{}
            .time-wrapper{
              position: relative;
              margin-right: 25px;
              text-align: right;
            }
          }
          .s-body-time {
            line-height: 33px;
            min-width: 53px;
          }
          .staffing-select-row {
            position: absolute;
            right: -42px;
            top: 5px;
            label {
              opacity: 0;
              &:hover {
                opacity: 1;
              }
            }
          }
        }
        .s-body-wrapper {
          background-color: #FFF;
          height: 33px;
          border-bottom: solid 1px #F5F5F5;
          .s-body-item {
            float: left;
            width: 81px;
            height: 32px;
            color: #626262;
            font-family: "Open Sans", sans-serif;
            font-size: 12px;
            line-height: 17px;
            margin-right: 24px;
            padding: 8px 0;
            position: relative;
            &:hover {
              .action-btn {
                display: block;
              }
              .bullet {
                display: none;
              }
              .staffing-check {
                display: block;
              }
              .text {
                padding-left: 24px;
              }
            }
            .staffing-check {
              position: absolute;
              top: 4px;
              left: 4px;
              display: none;
            }
            .text {
              height: 17px;
              color: #626262;
              font-family: "Open Sans", sans-serif;
              font-size: 12px;
              line-height: 17px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 62px;
              padding-left: 8px;
            }
            .bullet {
              height: 8px;
              width: 8px;
              float: left;
              margin-top: 5px;
              border-radius: 4px;
              margin-right: 2px;
              margin-left: 6px;
              &.green {
                background-color: #68B814;
              }
              &.red {
                background-color: #f43406;
              }

              &.grey {
                background-color: #aaa7a4;
              }
            }
            .action-btn {
              width: 24px;
              height: 24px;
              position: absolute;
              right: -21px;
              top: 5px;
              padding: 3px;
              border-radius: 4px;
              display: none;
              &:hover {
                cursor: pointer;
                background: #e5e5e5;
                ul.action-menu {
                  display: block;
                }
              }
              .dot {
                width: 4px;
                height: 4px;
                background: #8e8e8e;
                margin: 1.5px auto;
                border-radius: 2px;
              }
            }
            ul.action-menu {
              -webkit-padding-start: 0;
              list-style: none;
              -webkit-box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);
              box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);
              position: absolute;
              top: 23px;
              right: 0;
              width: 111px;
              display: none;
              z-index: 999;
              li {
                height: 32px;
                background-color: #F5F5F5;
                line-height: 32px;
                padding-left: 8px;
                &:hover {
                  cursor: pointer;
                  background-color: #ededed;
                }
              }
            }
          }
        }
      }
      .s-container {
        /*overflow: hidden;*/
        height: 20px;
        &.last-row {
          padding-bottom: 65px;
        }
        .s-wrapper {
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// SlotsTable.vue?7d809bce